export const options = [
  {
    option_name: "ご契約者名",
    required_optional: 1,
    option_type: 0,
    tel_flg: 0,
    name_flg: 1,
    company_name_flg: 0,
    zip_code_flg: 0,
    address_flg: 0,
    space_flg: 0,
    mail_address_flg: 0,
    form_tel_flg: 0,
    multi_text_flg: 0,
    half_width_number_flg: 0,
    option_comment: "",
    option_default_value: "",
    change_value_conf: 0,
    option_select: [],
    depend_service_names: [],
    depend_option_name: "",
    depend_select_names: [],
  },
  {
    option_name: "ふりがな",
    required_optional: 1,
    option_type: 0,
    tel_flg: 0,
    name_flg: 0,
    company_name_flg: 0,
    zip_code_flg: 0,
    address_flg: 0,
    space_flg: 1,
    mail_address_flg: 0,
    form_tel_flg: 0,
    multi_text_flg: 0,
    half_width_number_flg: 0,
    option_comment: "",
    option_default_value: "",
    change_value_conf: 0,
    option_select: [],
    depend_service_names: [],
    depend_option_name: "",
    depend_select_names: [],
  },
  {
    option_name: "メールアドレス",
    required_optional: 1,
    option_type: 0,
    tel_flg: 0,
    name_flg: 0,
    company_name_flg: 0,
    zip_code_flg: 0,
    address_flg: 0,
    space_flg: 0,
    mail_address_flg: 1,
    form_tel_flg: 0,
    multi_text_flg: 0,
    half_width_number_flg: 0,
    option_comment: "",
    option_default_value: "",
    change_value_conf: 0,
    option_select: [],
    depend_service_names: [],
    depend_option_name: "",
    depend_select_names: [],
  },
  {
    option_name: "ご契約電話番号",
    required_optional: 1,
    option_type: 0,
    tel_flg: 1,
    name_flg: 0,
    company_name_flg: 0,
    zip_code_flg: 0,
    address_flg: 0,
    space_flg: 0,
    mail_address_flg: 0,
    form_tel_flg: 0,
    multi_text_flg: 0,
    half_width_number_flg: 0,
    option_comment: "",
    option_default_value: "",
    change_value_conf: 0,
    option_select: [],
    depend_service_names: [],
    depend_option_name: "",
    depend_select_names: [],
  },
];
